import Vue from "vue";
import phone from "./Phone.vue";
import { pageScroll } from "./../../assets/utils/utils";
import router from "./../../router/index";
// let PhoneConstructor = Vue.extend(phone);
let PhoneConstructor = Vue.extend(require('./Phone.vue').default);
let instance = new PhoneConstructor({
  el: document.createElement("div")
});

PhoneConstructor.prototype.closeConfirm = function() {
  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);
};
PhoneConstructor.prototype.close = function() {
  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);
  document.getElementsByTagName("body")[0].style.overflow = "visible";
  pageScroll.unlock();
  router.go(-1);
  window.removeEventListener("popstate", onBrowserBack);
};
const onBrowserBack = function() {
  const el = instance.$el;
  el.parentNode && el.parentNode.removeChild(el);
  // this.close();
  // return;
  // // this.
  // // 这里写点击返回键时候的事件
  // // 比如判断需求执行back()或者go(-2)或者PopupShow=false隐藏弹框
};
PhoneConstructor.prototype.open = function() {
  document.body.appendChild(instance.$el);
  instance.isShow = true;
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  pageScroll.lock();
  window.history.pushState(null, null, document.URL);
  window.addEventListener("popstate", onBrowserBack);
};
const Phone = (options = {}) => {
  console.log(instance.$el)
  document.body.appendChild(instance.$el);
  instance.isShow = true;
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  pageScroll.lock();
  window.history.pushState(null, null, document.URL);

  window.addEventListener("popstate", onBrowserBack);
  instance.opts = options.opts;
  setTimeout(() => {
    var allInput = document.getElementsByTagName("input");
    for (let i = 0; i < allInput.length; i++) {
      allInput[i].addEventListener("blur", function() {
        setTimeout(() => {
          const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
          window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
      });
    }
  }, 200);
};
export  {
  Phone
};
